export const PAD = 5.5;
export const DEFAULT_SIZES = { title: 7.5, subheader: 3.8, details: 3.4, message: 3.6 };
export const SIZE_RANGES = { title: [3, 16], subheader: [2, 9], details: [2, 8], message: [2, 9] };
export const TEXT_KINDS = ["title", "subheader", "details", "message"];

export const sizeOf = (ev, kind) => ev[`${kind}_size`] || DEFAULT_SIZES[kind];
export const posOf = (ev, kind) => ev[`${kind}_pos`] || null;

export const messagePlacement = (ev) => {
  if (!ev.message?.trim()) return null;
  if (ev.message_placement && ev.message_placement !== "auto") return ev.message_placement;
  return ev.display_mode === "overlay" ? "image" : "below";
};

// Mirrors gif_service._placement so the editor, guest page and GIF agree.
export const placement = (ev) => {
  const kinds = ["title"];
  if (ev.sub_header) kinds.push("subheader");
  if (ev.date || ev.time || ev.place) kinds.push("details");
  const onImage = ev.display_mode === "overlay" ? [...kinds] : [];
  const below = ev.display_mode === "below" ? [...kinds] : [];
  const mp = messagePlacement(ev);
  if (mp === "image") onImage.push("message");
  if (mp === "below") below.push("message");
  return { onImage, below };
};
